import FormStepsStore from './FormStepsStore'

let activeFormStepsStore: FormStepsStore<any, any> | undefined

export const setActiveFormStepsStore = (
  store: FormStepsStore<any, any> | undefined
) => {
  activeFormStepsStore = store
}

export const getActiveFormStepsStore = () => activeFormStepsStore
